





















































































































































































































































































import Vue from 'vue';
import VueCompositionAPI, {defineComponent, ref, computed, onMounted, onBeforeUnmount} from '@vue/composition-api';
import {
  Activity,
  CandidateTransportationItem,
  getDateTimeAccordingToTimeZone,
  UserActivityCategoryEnum,
} from '@mobi-components/global-solution';
import FlightDetailsCard, {ActivityWithTags} from '@common/flight-details-card-versatile.vue';
import PoweredByMobiFooter from '@common/powered-by-mobi-footer.vue';
import BookingDialogVue from '../../summary-page/summary-booking/booking-modal.vue';
// @ts-ignore
import loading from '@common/loader.vue';
import {
  downloadAlternatives,
  getAllSolutionFilters,
  getAmexSolution,
  getDisplayFlights,
  getDisplayHotels,
  getSessionId,
  getTripId,
  isActivityBooked,
  selectAlternative,
  toggleFlightOrStay,
  toggleSolutionTags,
} from '@/store/state/helpers';
import MainFlightDetails from '@common/main-flight-card/flight-details-main-flight.vue';
import SticyFlight from '@common/main-flight-card/sticky-flight.vue';
import {
  AmexFilter,
  SearchInput,
  AmexDropdown,
  InterestDropItem,
  Tag,
  TagExt,
} from '@mobi-components/amex-bluesky-components';
import {
  TIME_FILTER_UPDATED,
  TIME_FILTER_UPDATE_STARTED,
  TRAVELERS_FILTER_UPDATED,
  TRAVELERS_FILTER_UPDATE_STARTED,
  useSolutionFilters,
  VueWithModal,
} from '../../solution-views/summary-filters';
import FlightIcon from '../../svg/airplane2.vue';
import {FilterSection, FilterTag} from '../../../app-types';
import {groupFilterSections, isFlightOverdue, isFlightsAvailable} from '@/store/state/utils';
import SectionsHeader from '../../solution-views/explore-view/sections-header.vue';
import SectionTab from '../../solution-views/explore-view/section-tab.vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import {SelectOptions, SelectValueText} from '@/store/api/load-alternatives';
import {useMainFlight} from '@common/main-flight-card/useMainFlightDetails';
import debounce from 'awesome-debounce-promise';
import {useParams} from '@/router/router';
import {APIService} from '@/services/api.service';
import {COMMON_DEBOUNCE_TIME_MS} from '@/config/common-constants';
import {mapFilterToFilterTag} from '@/store/api/download-domains';

Vue.use(VueCompositionAPI);
const AmexFlightDetails = defineComponent({
  components: {
    MainFlightDetails,
    FlightDetailsCard,
    loading,
    AmexFilter,
    SearchInput,
    AmexDropdown,
    InterestDropItem,
    Tag,
    TagExt,
    SectionsHeader,
    SectionTab,
    VueSlider,
    PoweredByMobiFooter,
    SticyFlight,
  },
  setup(_, {root}) {
    const SORT_LS_KEY = 'mobi-sort-settings-FLIGHTS';
    const isLoading = ref(false);
    const selectedValue = localStorage.getItem(SORT_LS_KEY);
    const selectedFilter = ref<SelectOptions>(selectedValue || SelectOptions.best_match);
    const alternatives = ref<ActivityWithTags[][]>([]);
    const params = useParams();
    const context = computed(() => {
      return params.value.contextName;
    });
    // const availableAlternatives = ref<Activity[][]>([[],[]]);
    const destinationFlightTime = ref(36);
    const destinationFlightTimeChange = debounce((value) => {
      destinationFlightTime.value = value;
    }, 300);
    const homeFlightTime = ref(36);
    const homeFlightTimeChange = debounce((value) => {
      homeFlightTime.value = value;
    }, 300);
    const destinationFlightDepart = ref([0, 24]);
    const destinationFlightDepartChange = debounce((value) => {
      destinationFlightDepart.value = value;
    }, 300);
    const destinationFlightArrive = ref([0, 24]);
    const destinationFlightArriveChange = debounce((value) => {
      destinationFlightArrive.value = value;
    }, 300);
    const homeFlightDepart = ref([0, 24]);
    const homeFlightDepartChange = debounce((value) => {
      homeFlightDepart.value = value;
    }, 300);
    const homeFlightArrive = ref([0, 24]);
    const onHomeFlightArriveChange = debounce((value) => {
      homeFlightArrive.value = value;
    }, 300);
    const formatFlightDuration = (v: number) => {
      if (v === 36) {
        return 'Any duration';
      }
      return `Less than ${v} Hours`;
    };
    const formatFlightBounds = ([from, to]: number[]) => {
      if (to === 24 && from === 0) {
        return 'Any time';
      }
      const toSuffix = to < 12 || to === 24 ? 'am' : 'pm';
      const toPrefix = to % 12 === 0 ? `12` : `${to % 12}`;
      const fromSuffix = from < 12 || from === 24 ? 'am' : 'pm';
      const fromPrefix = from % 12 === 0 ? `12` : `${from % 12}`;
      return `Anytime after ${fromPrefix}${fromSuffix} and before ${toPrefix}${toSuffix}`;
    };
    const destinationFlightDepartValue = computed(() => formatFlightBounds(destinationFlightDepart.value));
    const destinationFlightArriveValue = computed(() => formatFlightBounds(destinationFlightArrive.value));
    const homeFlightDepartValue = computed(() => formatFlightBounds(homeFlightDepart.value));
    const homeFlightArriveValue = computed(() => formatFlightBounds(homeFlightArrive.value));
    const destinationFlightTimeValue = computed(() => {
      return formatFlightDuration(destinationFlightTime.value);
    });
    const homeFlightTimeValue = computed(() => {
      return formatFlightDuration(homeFlightTime.value);
    });
    const solution = computed(() => {
      const s = getAmexSolution();
      return s;
    });
    const isFlightAvailable = computed(() => {
      return isFlightsAvailable(selectedFlights.value);
    });
    const isFlightInThePast = computed(() => {
      return isFlightOverdue(selectedFlights.value);
    });
    const flightExplanations = computed(() => {
      const flight = selectedFlights.value.find(Boolean);
      return flight?.explanations ? flight.explanations.join(', ') : '';
    });
    const isFlightsOn = computed(() => {
      return getDisplayFlights();
    });
    const toggleFlights = async () => {
      const newTripId = getTripId();
      const displayFlights = getDisplayFlights();
      const displayHotels = getDisplayHotels();
      isLoading.value = true;
      await toggleFlightOrStay(newTripId, !displayFlights, displayHotels);
      isLoading.value = false;
    };
    const selectedFlights = computed(() => {
      return solution.value?.activities.filter((x) => x.category === UserActivityCategoryEnum.FLIGHT) || [];
    });
    const flightType = computed(() => {
      const isBooked = selectedFlights.value.some((x) => isActivityBooked(x.id));
      return isBooked ? 'Booked' : 'Selected';
    });
    const availableTags = computed(() => {
      return getAllSolutionFilters();
    });
    const additionalTags = computed(() => {
      const y = availableTags.value.filter((x) => x.domain === UserActivityCategoryEnum.TRANSPORTATION);
      return y.filter((x) => x.value);
    });
    const selectedNumber = computed(() => {
      return additionalTags.value.length;
    });
    const selectedIcon = computed(() => {
      return FlightIcon;
    });
    const selectedCategory = computed(() => {
      return UserActivityCategoryEnum.TRANSPORTATION;
    });
    const activatedFilters = ref<Record<string, boolean>>({});
    const filterValue = ref('');
    const flightFilterOptions = ref([]);
    const activeFilterSection = ref('');
    const isSectionVisible = ref(true);
    const loadFilters = (keyword: string) => {
      return APIService.get('domain/filter/suggestions', {
        params: {
          mode: process.env.VUE_APP_MODE,
          category: UserActivityCategoryEnum.TRANSPORTATION,
          keyword,
          session_id: getSessionId(),
          context: context.value,
        },
      });
    };
    const debouncedFilters = debounce(loadFilters, COMMON_DEBOUNCE_TIME_MS);
    const onFilterValueChange = async (value: string) => {
      filterValue.value = value;
      if (!value) {
        flightFilterOptions.value = [];
      }
      if (value) {
        const res = await debouncedFilters(value);
        // @ts-ignore
        const candidates = res?.candidates || [];
        flightFilterOptions.value = candidates.map(mapFilterToFilterTag);
      }
    };
    const toggleTag = (value: FilterTag) => {
      activatedFilters.value[value.id] = !activatedFilters.value[value.id];
      activatedFilters.value = {...activatedFilters.value};
      toggleSolutionTags([{...value, value: !value.value}]);
      filterValue.value = '';
    };
    const activeFilters = computed(() => {
      const allFlightTags = (alternatives.value || [])
        .map((x) => {
          return x
            .map((flight) => {
              return (flight?.source?.content?.explanations || [])
                .concat(flight?.source?.content?.tags || [])
                .concat(flight?.source?.content?.types || [])
                .concat(flight?.types || []);
            })
            .flat();
        })
        .flat();
      const s = new Set(allFlightTags);
      const allAvailableFilters = availableTags.value.filter((x) => s.has(x.name));
      const sections = groupFilterSections(allAvailableFilters, UserActivityCategoryEnum.TRANSPORTATION);
      return sections.map((x) => ({...x, id: x.name}));
    });
    const availableSections = computed(() => {
      return activeFilters.value.filter((x) => x.options.length);
    });
    const isDurationActive = ref(false);
    const isTimingActive = ref(false);
    const openDuration = () => {
      isDurationActive.value = true;
      isTimingActive.value = false;
      isSectionVisible.value = false;
    };
    const openTiming = () => {
      isDurationActive.value = false;
      isTimingActive.value = true;
      isSectionVisible.value = false;
    };
    const activeSection = computed(() => {
      if (isDurationActive.value || isTimingActive.value) {
        return null;
      }
      const active = activeFilters.value.find((x) => x.id === activeFilterSection.value);
      const first = activeFilters.value.find((x) => Boolean(x));
      if (!active) {
        return first;
      }
      return active;
    });
    const activeSectionId = computed(() => {
      return activeSection.value ? activeSection.value.id : '';
    });
    const availableFilterTags = computed(() => {
      const tags = (activeSection.value ? activeSection.value.options : []) || [];
      const tagsLength = tags.length;
      const rest = tags.filter((x) => !activatedFilters.value[x.id]);
      return tagsLength > 20
        ? rest.slice(0, 20).map((x) => ({...x, isActive: activatedFilters.value[x.id]}))
        : tags.slice(0, 20).map((x) => ({...x, isActive: activatedFilters.value[x.id]}));
    });
    const onSelectSection = (section: FilterSection) => {
      isDurationActive.value = false;
      isTimingActive.value = false;
      // if (activeFilterSection.value === section.id) {
      // isSectionVisible.value = true;
      // } else {
      isSectionVisible.value = true;
      // }
      activeFilterSection.value = section.id;
    };
    const filterOptions = computed(() => {
      return flightFilterOptions.value;
    });
    const loadAlternativeFlights = async () => {
      isLoading.value = true;
      alternatives.value = await Promise.all(
        selectedFlights.value.map((x) => {
          return new Promise<ActivityWithTags[]>((resolve) => {
            downloadAlternatives(x.id, selectedFilter.value).then((alternatives) => {
              const flightsWithTags = (alternatives?.alternatives || []).map((flight) => {
                const tags = (flight?.source?.content?.explanations || [])
                  .concat(flight?.source?.content?.tags || [])
                  .concat(flight?.source?.content?.types || [])
                  .concat(flight?.types || []);
                return {
                  ...flight,
                  flightTags: new Set(tags),
                  matchedTags: [],
                };
              });
              resolve(flightsWithTags);
            });
          });
        }),
      );
      isLoading.value = false;
    };
    const updateLoadingState = () => {
      isLoading.value = true;
    };
    const checkFlightTime = (flight: Activity, departureBounds: number[], arrivealBounds: number[]) => {
      const [departFrom, departTo] = departureBounds;
      const [arriveFrom, arriveTo] = arrivealBounds;
      const departureTS = (flight.source?.content as CandidateTransportationItem)?.departure_timestamp;
      const arrivalTS = (flight.source?.content as CandidateTransportationItem)?.arrival_timestamp;
      const departureTZ = (flight.source?.content as CandidateTransportationItem)?.origin?.time_zone;
      const arrivalTZ = (flight.source?.content as CandidateTransportationItem)?.destination?.time_zone;
      const departureDate = getDateTimeAccordingToTimeZone(new Date(departureTS * 1000), departureTZ);
      const arrivalDate = getDateTimeAccordingToTimeZone(new Date(arrivalTS * 1000), arrivalTZ);
      const departureHour = departureDate.getHours();
      const arrivalHour = arrivalDate.getHours();
      return (
        departFrom <= departureHour && departTo >= departureHour && arriveFrom <= arrivalHour && arriveTo >= arrivalHour
      );
    };
    const availableAlternatives = computed(() => {
      const hash = activeFlightFilters.value.reduce((r: Set<string>, x) => {
        r.add(x);
        return r;
      }, new Set<string>());
      const res = (alternatives.value || []).map((x, index) => {
        return x
          .filter((flight) => flight.source?.content?.contexts.includes(context.value))
          .filter((flight) => {
            const tags = flight?.flightTags || new Set([]);
            const hashInTags = [...hash].some((h) => tags.has(h));
            return (
              (hashInTags || activeFlightFilters.value.length === 0) &&
              ((index === 0 && flight.duration < destinationFlightTime.value * 60 * 60) ||
                (index === 1 && flight.duration < homeFlightTime.value * 60 * 60)) &&
              ((index === 0 && checkFlightTime(flight, destinationFlightDepart.value, destinationFlightArrive.value)) ||
                (index === 1 && checkFlightTime(flight, homeFlightDepart.value, homeFlightArrive.value)))
            );
          })
          .map((flight) => {
            const matchedTags = [...hash].filter((x) => flight.flightTags.has(x));
            return {
              ...flight,
              matchedTags,
            };
          })
          .sort((a, b) => b.matchedTags.length - a.matchedTags.length);
      });
      return res;
    });
    const defaultNumberOfShownActivities = 3;
    const numberOfShownAlternatives = ref({
      'Departing Flights': defaultNumberOfShownActivities,
      'Returning Flights': defaultNumberOfShownActivities,
    });
    const showMore = (id: string) => {
      // @ts-ignore
      numberOfShownAlternatives.value[id] = (numberOfShownAlternatives.value[id] || 0) + defaultNumberOfShownActivities;
    };
    const flights = computed(() => {
      const alt = alternatives.value.filter((x) => x.some((y) => y.source?.content?.contexts?.includes(context.value)));
      const res = selectedFlights.value
        .filter((x) => x.source.content?.contexts.includes(context.value))
        .map((x: Activity, index: number) => {
          if (index === 0) {
            return {
              text: 'Departing Flights',
              flight: x,
              alternatives: alt[index] || [],
            };
          }
          return {
            text: 'Returning Flights',
            flight: x,
            alternatives: alt[index] || [],
          };
        });
      return res || [];
    });

    const firstFlight = computed(() => {
      return flights.value.find(Boolean);
    });
    const replaceFlight = async (alternativeFlight: Activity, flightId: string) => {
      numberOfShownAlternatives.value = {
        'Departing Flights': defaultNumberOfShownActivities,
        'Returning Flights': defaultNumberOfShownActivities,
      };
      isLoading.value = true;
      await selectAlternative(flightId, alternativeFlight);
      await loadAlternativeFlights();
      isLoading.value = false;
    };
    loadAlternativeFlights();
    const {availableSolutionsFlightTags, ...filters} = useSolutionFilters(root as VueWithModal);
    const activeFlightFilters = computed(() => {
      const x = availableSolutionsFlightTags.value.filter((x) => x.value).map((x) => x.name);
      return x;
    });
    const flightTimeFormatter = (v: number) => {
      if (v > 0 && v < 12) {
        return `${v}am`;
      }
      if (v === 0) {
        return `12am`;
      }
      if (v >= 12 && v < 24) {
        return `${v - 12}pm`;
      }
      if (v === 24) {
        return `12am`;
      }
    };
    const isSolutionAvailable = computed(() => {
      return Boolean(solution.value);
    });
    const onBookingOpen = () => {
      (root as VueWithModal).$modal.show(BookingDialogVue, {});
    };
    const selectedFilterLabel = computed(() => {
      return SelectValueText[selectedFilter.value];
    });
    const sortOptions = [
      {value: SelectOptions.best_match, label: SelectValueText[SelectOptions.best_match]},
      {value: SelectOptions.price_high, label: SelectValueText[SelectOptions.price_high]},
      {value: SelectOptions.price_low, label: SelectValueText[SelectOptions.price_low]},
    ];
    const isSortDropdownActive = ref(false);
    const onDeactivateSortDropdown = () => {
      isSortDropdownActive.value = false;
      flightFilterOptions.value = [];
    };
    const onFilterChange = (value: SelectOptions) => {
      onDeactivateSortDropdown();
      selectedFilter.value = value;
      loadAlternativeFlights();
      localStorage.setItem(SORT_LS_KEY, value);
    };
    const onActivateSortDropdown = () => {
      isSortDropdownActive.value = true;
    };
    onMounted(() => {
      activatedFilters.value = availableTags.value.reduce((res: Record<string, boolean>, x) => {
        res[x.id] = x.value;
        return res;
      }, {});
      root.$on(TIME_FILTER_UPDATE_STARTED, updateLoadingState);
      root.$on(TRAVELERS_FILTER_UPDATE_STARTED, updateLoadingState);
      root.$on(TIME_FILTER_UPDATED, loadAlternativeFlights);
      root.$on(TRAVELERS_FILTER_UPDATED, loadAlternativeFlights);
      document.addEventListener('click', onDeactivateSortDropdown);
    });
    onBeforeUnmount(() => {
      root.$off(TIME_FILTER_UPDATED, loadAlternativeFlights);
      root.$off(TRAVELERS_FILTER_UPDATED, loadAlternativeFlights);
      root.$off(TIME_FILTER_UPDATE_STARTED, updateLoadingState);
      root.$off(TRAVELERS_FILTER_UPDATE_STARTED, updateLoadingState);
      document.removeEventListener('click', onDeactivateSortDropdown);
    });
    const {firstArrivalTimeOnly, firstArrivalDate, lastDepartureTime} = useMainFlight();
    const firstArrivalTime = computed(() => {
      return `${firstArrivalTimeOnly.value}, ${firstArrivalDate.value}`;
    });

    return {
      flights,
      firstFlight,
      numberOfShownAlternatives,
      showMore,
      replaceFlight,
      alternatives,
      availableAlternatives,
      isLoading,
      isSolutionAvailable,
      selectedFlights,
      ...filters,
      activeFlightFilters,
      additionalTags,
      selectedNumber,
      selectedIcon,
      selectedCategory,
      toggleTag,
      availableSections,
      activeSectionId,
      availableFilterTags,
      onSelectSection,
      filterValue,
      filterOptions,
      isSectionVisible,
      destinationFlightTime,
      homeFlightTime,
      flightTimeFormatter,
      isDurationActive,
      isTimingActive,
      openDuration,
      openTiming,
      destinationFlightTimeValue,
      destinationFlightTimeChange,
      homeFlightTimeValue,
      homeFlightTimeChange,
      destinationFlightDepart,
      destinationFlightArrive,
      homeFlightDepart,
      homeFlightArrive,
      destinationFlightDepartValue,
      destinationFlightDepartChange,
      destinationFlightArriveValue,
      destinationFlightArriveChange,
      homeFlightDepartValue,
      homeFlightDepartChange,
      homeFlightArriveValue,
      onHomeFlightArriveChange,
      isFooterAvailable: process.env.VUE_APP_IS_FOOTER_VISIBLE || false,
      flightType,
      isFlightAvailable,
      flightExplanations,
      isFlightInThePast,
      onBookingOpen,
      selectedFilterLabel,
      selectedFilter,
      onFilterChange,
      isSortDropdownActive,
      onActivateSortDropdown,
      sortOptions,
      isFlightsOn,
      toggleFlights,
      firstArrivalTime,
      lastDepartureTime,
      onFilterValueChange,
      bookingDisclaimer:
        process.env.VUE_APP_BOOKING_DISCLAIMER ||
        'Once you’re ready to book, you’ll be redirected to AmexTravel.com where you can enjoy any travel benefits associated with your Card and, if eligible, use Membership Rewards® points at checkout.',
    };
  },
});
export default AmexFlightDetails;
